import React from "react";
import Dispatcher from "../../dispatcher";

var ContextModal = require("../ui_elements/context-modal").ContextModal;
var Isvg = require("../../../vendor/react-inlinesvg");

/*
  Renders the guided tour with a transparent "screen" added to focus the target element
  See "getDefaultStep" for available options

*/
class Tour extends React.Component {
  constructor() {
    super();
    this.state = {
      hidden: true,
      steps: [{}],
      currentStep: false,
      displayedStep: {},
      menuVisible: false
    };

    this.onboardingContainerRef = React.createRef();

    this._windowBlur = this._windowBlur.bind(this);
    this._newTour = this._newTour.bind(this);
    this._endTour = this._endTour.bind(this);
    this._setupScreenResize = this._setupScreenResize.bind(this);
    this._highlightModalElement = this._highlightModalElement.bind(this);
    this._previousStep = this._previousStep.bind(this);
    this._nextStep = this._nextStep.bind(this);
    this._runStep = this._runStep.bind(this);
    this._checkMenusAndHighlight = this._checkMenusAndHighlight.bind(this);
    this._escapeKey = this._escapeKey.bind(this);
    this._closeOnboarding = this._closeOnboarding.bind(this);
    this._removeScreens = this._removeScreens.bind(this);
  }

  componentDidMount() {
    this.mounted = true;

    Dispatcher.bind(Dispatcher.NEW_TOUR, this._newTour);
    Dispatcher.bind(Dispatcher.END_TOUR, this._endTour);
    Fraction.TourQueue = Fraction.TourQueue || [];
    Fraction.PreviousTourQueue = Fraction.PreviousTourQueue || [];
    this._nextStep();
    $(window).on("keyup", this._escapeKey);
    window.addEventListener("blur", this._windowBlur);
    $("#tour-container")
      .find(":focusable")
      .first()
      .focus();
  }

  componentWillUnmount() {
    this.mounted = false;

    if (this.state.currentStep) {
      this.state.currentStep.setup = false;
      Fraction.TourQueue.unshift(this.state.currentStep);
    }
    this._closeOnboarding();
    Dispatcher.unbind(Dispatcher.NEW_TOUR, this._newTour);
    Dispatcher.unbind(Dispatcher.END_TOUR, this._endTour);
    $(window).unbind("keyup", this._escapeKey);
    window.removeEventListener("blur", this._windowBlur);
  }

  _windowBlur() {
    var focusElement = $("#tour-container")
      .find(":focusable")
      .first()
      .focus();
    if (this.state.currentStep) {
      Fraction.Helpers.focusOnElement(focusElement);
    }
  }

  _newTour(steps) {
    Dispatcher.emit(Dispatcher.MODAL_OPEN);
    Fraction.TourQueue = steps;
    Fraction.PreviousTourQueue = [];

    setTimeout(
      () =>
        $("#tour-container")
          .find(":focusable")
          .last()
          .focus(),
      1000
    );

    this._nextStep();
    this._setupScreenResize();
  }

  _endTour() {
    this._closeOnboarding(true);
  }

  _topTrapKey() {
    $("#tour-container")
      .find(":focusable")
      .last()
      .focus();
  }

  _bottomTrapKey() {
    $("#tour-container")
      .find(":focusable")
      .first()
      .focus();
  }

  _setupScreenResize() {
    // Set up resize listener here instead of on component load because we unbind it
    // when we close the tour, but still want it to be in effect if we cancel out
    // and come back into the tour.
    if (!this.state.screenResizeSet) {
      $(window).on("resize.tour", () => {
        var step = this.state.displayedStep;
        step.target = $(step.targetSelector);
        this._runStep(step);

        // Also check screen width and save so menu can adjust in render
        this.setState({
          documentWidth: $(document).width(),
          screenResizeSet: true
        });
      });
    }
  }

  _highlightModalElement(element) {
    // Remove any previously defined screens
    this._removeScreens();

    if (!element[0]) {
      return;
    }

    // Calculate bounding box of target element
    var x = element[0].getBoundingClientRect().left;
    var y = element[0].getBoundingClientRect().top;
    var width = element.outerWidth();
    var height = element.outerHeight();

    // Build 4 gray boxes to surround the target element
    var box1 = $(
      "<div class='tour-screen' style='left:0;top:0;right:0px;height:" +
        y +
        "px'></div>"
    );
    var box2 = $(
      "<div class='tour-screen' style='left:0;bottom:0;top:" +
        (y + height) +
        "px;right:0px;'></div>"
    );
    var box3 = $(
      "<div class='tour-screen' style='left:0;top:" +
        y +
        "px;bottom:" +
        ($(window).height() - (y + height)) +
        "px;width:" +
        x +
        "px;'></div>"
    );
    var box4 = $(
      "<div class='tour-screen' style='right:0;top:" +
        y +
        "px;bottom:" +
        ($(window).height() - (y + height)) +
        "px;left:" +
        (x + width) +
        "px;'></div>"
    );

    // Make a transparent box over element that goes to next SSO step
    var coverBox = $("<div class='tour-screen clear-screen'></div>");
    coverBox.css("width", width);
    coverBox.css("height", height);
    coverBox.css("left", x);
    coverBox.css("top", y);

    /*
     * Coverbox click removed for now, but could be easily put back in

    coverBox.click(function() {
      this._nextStep();
    }.bind(this));
    */

    var boxes = [box1, box2, box3, box4];

    // Add boxes to DOM
    $(".tour-screen-container").append(coverBox);

    $.each(boxes, (key, value) => {
      $(".tour-screen-container").append(value);

      value.click(this._closeOnboarding);
    });
  }

  _focusModal(element, direction) {
    if (!element[0]) {
      return;
    }

    var box = element[0].getBoundingClientRect();

    // Some basic arithmetic kept in, in case we want to change width in future
    var menuTop;
    var menuLeft;
    var arrowLeft;

    // Make sure menu fits in bounds of screen
    function checkTop(top) {
      var maxHeight = $("#bookshelf").height() - 138;
      var minHeight = 0;

      if (top > maxHeight) {
        return maxHeight;
      } else if (top < minHeight) {
        return minHeight;
      } else {
        return top;
      }
    }
    function checkLeft(left) {
      var maxLeft = $("#bookshelf").width() - 138;
      var minLeft = 5;

      var defaultArrowLeft = 337;

      if (left > maxLeft) {
        return { left: maxLeft };
      } else if (left < minLeft) {
        return {
          left: minLeft,
          arrowLeft: 168
        };
      } else {
        return { left: left };
      }
    }

    var leftOptions;
    switch (direction) {
      case "top":
        leftOptions = checkLeft(box.right - 375);

        this.setState({
          menuLeft: leftOptions.left,
          menuTop: checkTop(box.top - 138 - 5),
          arrowLeft: leftOptions.arrowLeft || 337,
          arrowTop: 138,
          arrowClass: "arrow-down"
        });
        break;
      case "bottom":
        menuTop = box.bottom + 5;

        leftOptions = checkLeft(box.right - 375);

        this.setState({
          menuLeft: leftOptions.left,
          menuTop: checkTop(menuTop),
          arrowLeft: leftOptions.arrowLeft || 337,
          arrowTop: -5,
          arrowClass: "arrow-up"
        });

        break;
      case "left":
        this.setState({
          menuLeft: box.left - 375 - 5,
          menuTop: checkTop(box.top),
          arrowLeft: 375,
          arrowTop: 30,
          arrowClass: "arrow-right"
        });
        break;
      case "right":
        this.setState({
          menuLeft: box.right + 5,
          menuTop: checkTop(box.top),
          arrowLeft: -5,
          arrowTop: 30,
          arrowClass: "arrow-left"
        });
        break;
      default:
        this.setState({
          menuLeft: box.right - 375,
          menuTop: checkTop(box.bottom + 5),
          arrowLeft: 337,
          arrowTop: -5,
          arrowClass: "arrow-up"
        });
        break;
    }
  }

  _previousStep() {
    if (Fraction.PreviousTourQueue.length > 0) {
      Fraction.TourQueue.unshift(this.state.currentStep);
      Fraction.TourQueue.unshift(Fraction.PreviousTourQueue.pop());
      this._nextStep();
    }
  }

  _nextStep() {
    const previousStep = this.state.currentStep;
    this.setState(
      {
        currentStep: false
      },
      () => {
        if (previousStep) {
          if (previousStep.teardown) {
            previousStep.teardown();
          }
          Fraction.PreviousTourQueue.push(previousStep);
        }
        if (Fraction.TourQueue.length === 0) {
          this.setState({ hidden: true });
          this._closeOnboarding(true);
          return;
        }
        // Get default values for text that can be overwritten by individual functions
        let step = this._getDefaultStep();
        this.setState(
          {
            currentStep: $.extend(true, step, Fraction.TourQueue.shift()),
            hidden: true
          },
          () => {
            // Run set up function before showing step. If it returns true, we're all done
            let timeout = this.state.currentStep.timeout;
            if (this.state.currentStep.setup) {
              this.state.currentStep.setup();
            }
            setTimeout(() => {
              if (this.mounted) {
                // Wrap target as jquery object after a render
                this.state.currentStep.target = $(step.targetSelector);
                this._runStep(step);
                this.setState({ hidden: false });
                $("#tour-container")
                  .find(":focusable")
                  .last()
                  .focus();
              }
            }, timeout);
          }
        );
      }
    );
  }

  /*
  Default object for each step of the tour
  Note that runAfterStep is currently not implemented
  Also note that next/previous buttons are shown based on existance of steps before/after
  the current step in the array, so to display a "finish" button, include a step that
  returns true from the runBeforeStep callback, like this:
  {
    runBeforeStep: function(callback) { callback(true); }
  }
  */
  _getDefaultStep() {
    return {
      message: null,
      boldMessage: null,
      nextText: i18n.t("base.next"),
      previousText: false,
      hidden: false,
      setup: false,
      teardown: false,
      target: null,
      timeout: 250,
      theme: false,
      targetSelector: null,
      menuDirection: "left"
    };
  }

  _runStep(step) {
    // Set menu to invisible to start, then position menus, then show again
    this.setState({
      menuVisible: false
    });

    this._focusModal(step.target, step.menuDirection);

    this._checkMenusAndHighlight(step.target);

    this.setState({
      menuVisible: true
    });
  }

  // This is run after each step function to close opened menus and highlight
  // the target modal (unless the function handles it themselves)
  _checkMenusAndHighlight(target) {
    // Kind of hacky, but open account menu by simulating a click on the element if the
    // menu isn't open when our target is the account header.
    // Otherwise, close it if it's open on another step.
    // TODO: Remove this if no longer needed
    var accountMenuIsOpen = $("#user-dropdown-menu-1").width() > 0;
    if (
      (target.is($(".account-header")) && !accountMenuIsOpen) ||
      (!target.is($(".account-header")) && accountMenuIsOpen)
    ) {
      $("[data-menu-id='user-dropdown-menu-1']").click();
    }

    // After every step, highlight the targeted element, then focus on the next button
    // (so if a user keeps hitting enter, they keep going through the flow)
    Fraction.Helpers.runAfterRender(() => {
      if (this.mounted) {
        this._highlightModalElement(target);
        $(this.onboardingContainerRef.current).focus();
      }
    });
  }

  _escapeKey(e) {
    if (e.keyCode === 27) {
      this._closeOnboarding(true);
    }
  }

  _closeOnboarding(destroyTour) {
    Dispatcher.emit(Dispatcher.MODAL_CLOSE);
    this.setState({
      hidden: true,
      currentStep: false,
      menuVisible: false
    });

    if (destroyTour) {
      Fraction.TourQueue = [];
      Fraction.PreviousTourQueue = [];
    }

    Fraction.Helpers.focusOnElement(".lab-learn-more");

    Fraction.Helpers.runAfterRender(() => {
      this._removeScreens();
    });

    $(window).off("resize.tour");
  }

  _removeScreens() {
    $(".tour-screen").remove();
  }

  render() {
    var menuStyle = {
      left: this.state.menuLeft || "auto",
      top: this.state.menuTop || "auto",
      right: this.state.menuRight || "auto",
      bottom: this.state.menuBottom || "auto",
      display: this.state.currentStep && !this.state.hidden ? "inline" : "none",
      opacity: this.state.menuVisible ? 1 : 0
    };

    var arrowStyle = {
      left: this.state.arrowLeft,
      top: this.state.arrowTop
    };

    // Set width as well if less than our default
    // Also hide arrow just so we don't have to mess with location
    if (this.state.documentWidth < 375) {
      menuStyle.width = this.state.documentWidth;
      arrowStyle.display = "none";
    }

    const step = this.state.currentStep;

    var nextStepVisible = step.nextText;

    // For now, turning off previous buttons, but leaving in this option if we want
    // to customize
    var prevStepVisible = step.previousText;

    var menuClass = "tour-context-menu";

    var transitionClass = this.state.menuVisible ? "with-transition" : "";
    if (transitionClass) {
      menuClass += " with-transition";
    }
    if (this.state.currentStep.theme) {
      menuClass += " " + this.state.currentStep.theme;
    }

    return (
      <div className="tour-screen-container">
        {!this.state.hidden && (
          <div
            aria-hidden={true}
            onFocus={this._topTrapKey}
            className="traptabkey"
            tabIndex={0}
          />
        )}
        <div
          id="tour-container"
          className={menuClass}
          style={menuStyle}
          ref={this.onboardingContainerRef}
        >
          <button
            className="tour-close noButton"
            onClick={this._closeOnboarding}
          >
            <Isvg src="/img/x_gray.svg" />
            <span className="offScreen">{i18n.t("base.close")}</span>
          </button>
          <div className={this.state.arrowClass} style={arrowStyle} />
          <div className="tour-message">
            <h2>{i18n.t("review-mode.tour-header")}</h2>
            {step.boldMessage && (
              <div className="bold-message">{step.boldMessage}</div>
            )}
            <p>{step.message}</p>
            <p className="hidden-detail">{step.hiddenDetailMessage}</p>
          </div>
          <div className="tour-button-container">
            {prevStepVisible && (
              <button
                className="noButton previous-button"
                onClick={this._previousStep}
              >
                {step.previousText}
              </button>
            )}
            {nextStepVisible && (
              <button className="noButton next-button" onClick={this._nextStep}>
                {step.nextText}
              </button>
            )}
          </div>
        </div>
        {!this.state.hidden && (
          <div
            aria-hidden={true}
            onFocus={this._bottomTrapKey}
            className="traptabkey"
            tabIndex={0}
          />
        )}
      </div>
    );
  }
}

export default Tour;
